import { SignUpRequest } from "../auth";
import { User } from "../user";

export const signUpRequestFromUser = (user: User, password: string, password_confirmation: string, captcha_value: string | undefined): SignUpRequest => ({
    username: user!.username as string,
    password,
    password_confirmation,
    social_security: user!.social_security as string,
    email: user!.email as string,
    first_name: user!.first_name as string,
    last_name: user!.last_name as string,
    address_1: user!.address_1 as string,
    address_2: user!.address_2 as string,
    city: user!.city as string,
    state: user!.state as string,
    zip: user!.zip as string,
    captcha_value: captcha_value,
  } as SignUpRequest);
